import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { WHATSAPP_URL } from './WhatsAppIcon';
export function SubmitError() {
  return <div role="alert" className="flex items-start gap-3 rounded-xl border border-red-500/40 bg-red-500/10 p-4 text-sm" data-id="element-357" data-mp="2u4y0lkmm2me9">
      <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-358" data-mp="382mjimx4bjgo" />
      <p className="text-white/90" data-id="element-359" data-mp="3342xkmiiy7ob">
        No pudimos enviar tu mensaje. Revisá tu conexión e intentá de nuevo, o llamanos al{' '}
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="font-semibold text-neon underline-offset-2 hover:underline" data-id="element-360" data-mp="2ahqj3dy690vy">
          WhatsApp 11 5644 9518
        </a>
        .
      </p>
    </div>;
}